import { render, staticRenderFns } from "./NavShopBasket.vue?vue&type=template&id=23bbb975&scoped=true&"
import script from "./NavShopBasket.vue?vue&type=script&lang=js&"
export * from "./NavShopBasket.vue?vue&type=script&lang=js&"
import style0 from "./NavShopBasket.vue?vue&type=style&index=0&id=23bbb975&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bbb975",
  null
  
)

export default component.exports